module.exports = {
  API: process.env.NODE_ENV === 'development' ? 'http://localhost:3001/' : 'https://housesinapi.masoft.mx/',
  //API_IMAGES: process.env.NODE_ENV === "development" ? "http://localhost:3001" : "https://housesinapi.masoft.mx",
}